import Vue from 'vue'

import {
  BreadcrumbPlugin,
  CardPlugin,
  CollapsePlugin,
  DropdownPlugin,
  FormPlugin,
  FormCheckboxPlugin,
  FormFilePlugin,
  FormGroupPlugin,
  FormInputPlugin,
  FormRadioPlugin,
  FormTextareaPlugin,
  LayoutPlugin,
  InputGroupPlugin,
  ModalPlugin,
  NavPlugin,
  NavbarPlugin,
  PaginationPlugin,
  PaginationNavPlugin,
  SpinnerPlugin,
  TabsPlugin
} from 'bootstrap-vue'

[
  BreadcrumbPlugin,
  CardPlugin,
  CollapsePlugin,
  DropdownPlugin,
  FormPlugin,
  FormCheckboxPlugin,
  FormFilePlugin,
  FormGroupPlugin,
  FormInputPlugin,
  FormRadioPlugin,
  FormTextareaPlugin,
  InputGroupPlugin,
  LayoutPlugin,
  ModalPlugin,
  NavPlugin,
  NavbarPlugin,
  PaginationPlugin,
  PaginationNavPlugin,
  SpinnerPlugin,
  TabsPlugin
].forEach(comp => {
  Vue.use(comp)
})
